<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Registra Avanzamento
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="registraAvanzamento" v-bind="attrs" v-on="on">
            <v-icon color="success" large> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Invia Registrazione</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone per tornare indietro -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" v-bind="attrs" v-on="on">
            <v-icon color="error" large> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5">
      <v-container>
        <v-row align="center" justify="center">
          <!-- Colonna della card della causale -->
          <v-col cols="6">
            <!-- Card della quantità -->
            <v-card
              class="elevation-0"
              outlined
              style="border: 1px solid black"
            >
              <v-card-text>
                <v-container>
                  <v-row align="center" justify="center">
                    <v-col cols="12">
                      <span style="font-size: 20px">
                        Progressivo scatole raggiunto:
                      </span>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-col cols="6">
                      <v-text-field
                        background-color="#ffffff"
                        class="input-class centered-input"
                        dense
                        height="50px"
                        hide-details
                        label=""
                        style="
                          display: inline-block;
                          font-size: 20px;
                          font-weight: bold;
                          line-height: 25px;
                          max-width: 150px;
                          padding: 0px;
                        "
                        type="number"
                        v-model="qta_box"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Colonna della card della causale -->
          <v-col cols="6">
            <!-- Card della causale -->
            <v-card
              class="elevation-0"
              outlined
              style="border: 1px solid black"
            >
              <v-card-text>
                <v-container>
                  <v-row align="center" justify="center">
                    <v-col cols="12">
                      <span style="font-size: 20px"
                        >Indicare la causale della registrazione manuale</span
                      >
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="causale_sel"
                        :items="items_causali"
                        label="Causale"
                        item-text="des"
                        item-value="id_tabella"
                      >
                        <template #label>
                          <span class="">Causale</span>
                          <span
                            @click.stop
                            style="min-width: 500px; pointer-events: all"
                          >
                            <Modules
                              v-on:dialogModules="gettabelle"
                              tipo="CRISTAL_CAUSALE_REGISTRAZIONE"
                              nome="Causali di Registrazione"
                              setaction="settabella"
                              getaction="gettabella"
                              controller="Global"
                              filter="validita = 1"
                              :dati="[{ des: '' }]"
                            />
                          </span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog di avviso all'apertura del form -->
    <v-dialog v-model="conferma_dialog" persistent width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Registrazione Manuale
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="color: black; font-size: 20px"
            >La registrazione manuale non è la procedura standard: confermi di
            voler procedere alla compilazione di questo form?</span
          >
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-btn class="mr-5" @click="clickConfermaAnnulla">
                  <v-icon color="error" large>mdi-close</v-icon>
                </v-btn>
                <v-btn class="mr-5" @click="clickConfermaOk">
                  <v-icon color="success" large> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "RegistraAvanzamento",
  components: {
    Modules: () => import("@/components/TOOLS/Modules"),
    SnackbarQV,
  },
  props: {
    pz_per_scatola: { type: Number, default: null },
    work_order_sel: { type: Object, default: () => {} },
    ultima_scatola: { type: String, default: '' },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      // Variabili d'appoggio
      causale_sel: null,
      qta_box: 0,

      // Modal
      conferma_dialog: false,

      // Array
      items_causali: [],
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.gettabelle();

          /* Apro il dialog di conferma per chiedere
           * all'utente se vuole davvero usare questa
           * finestra di dialogo, che non è standard.*/
          this.$nextTick(() => {
            this.conferma_dialog = true;
          });
        }
      },
    },
  },
  methods: {
    clickChiudi() {
      this.resetProperties();
      this.$emit("click_chiudi");
    },
    clickConfermaAnnulla() {
      this.conferma_dialog = false;
      this.clickChiudi();
    },
    clickConfermaOk() {
      this.conferma_dialog = false;
    },
    gettabelle() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "CRISTAL_CAUSALE_REGISTRAZIONE",
          filter: "validita = 1",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_causali = res.data;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità tecnica rilevata, codice ${res.status}.`
            );
          }
        })
        .catch((err) => {
          // Stampo una snackbar di errore
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    registraAvanzamento() {
      // Controllo che i valori del form siano accettabili

      // Controllo la quantità da registrare
      if (
        this.qta_box <= 0 ||
        this.qta_box === null ||
        this.qta_box === undefined
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Sono presenti campi non compilati: definire quantità da registrare maggiori di 0."
        );
        return;
      }

      // Controllo la causale di registrazione
      if (this.causale_sel === null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Sono presenti campi non compilati: dichiarare la causale della registrazione manuale."
        );
        return;
      }

      // Controllo che l'ultima scatola si maggiore del progressivo scatole registrato
      if (parseInt(this.ultima_scatola) >= parseInt(this.qta_box)) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il progressivo scatole è più basso della quantità già registrata, impossibile salvare!"
        );
        return;
      }

      // Preparo la request
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatole",
          token: localStorage.getItem("user_token"),
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
          id_macchina: this.work_order_sel.id_macchina,
          progressivo: this.qta_box,
          ultima_scatola: this.ultima_scatola,
          id_causale: this.causale_sel,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Resetto le variabili di supporto
            this.resetProperties();
            /* Emetto un evento per segnalare
             * al componente padre di aggiornarsi */
            this.$emit("registra_avanzamento");
          } else {
            // Stampo una snackbar di errore
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità tecnica rilevata, codice errore: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          // Stampo una snackbar di errore
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );

          // Fermo l'overlay di caricamento.
          this.caricamento_dati = false;
        });
    },
    resetProperties() {
      this.causale_sel = null;
      this.qta_box = 0;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>